import axios from "axios";

const httpClient = axios.create({
    baseURL: `/api`,
    timeout: 60000
});

export default httpClient;